import { PBADashboardTPDSummary as Component } from './components/PBADashboardTPDSummary';
import Connector from './connector';

export const PBADashboardTPDSummary = () => <Connector component={Component} />;
